import { setState } from './helpers'

const mediaMutations = {
  SET_SLIDERS: setState('slides'),
  SET_SLIDE: setState('slide'),

  SET_TEXT_PAGES: setState('textPages'),
  SET_TEXT_PAGE: setState('textPage'),

  SET_MEDIA_CATEGORIES: setState('mediaCategories'),
  SET_MEDIAS: setState('medias'),
  SET_MEDIA_PAGE: setState('mediaPage'),
  SET_MEDIA_PAGE_FILES: setState('mediaPageFiles'),
  SET_MEDIA_FILES: setState('mediaFiles'),
  REMOVE_MEDIA_FILE(state, fileId) {
    state.mediaPageFiles = Array.isArray(state.mediaPageFiles)
      ? state.mediaPageFiles.filter((file) => String(file.id) !== String(fileId))
      : []

    if (Array.isArray(state.mediaFiles)) {
      const hadFile = state.mediaFiles.some((file) => String(file.id) === String(fileId))
      state.mediaFiles = state.mediaFiles.filter((file) => String(file.id) !== String(fileId))

      if (hadFile && typeof state.totalMediaFiles === 'number' && state.totalMediaFiles > 0) {
        state.totalMediaFiles -= 1
      }
    } else {
      state.mediaFiles = []
    }
  },
  SET_TOTAL_MEDIA_FILES: setState('totalMediaFiles')
}

export { mediaMutations }
